import React, { useEffect, useState } from 'react';
import './PaymentCallback.css';

const ROUTE_STATUS = {
  '/payment-success': 'DEBIT_SUCCESS',
  '/payment-error': 'DEBIT_FAILED',
  '/payment-cancel': 'DEBIT_CANCEL',
};

const PaymentCallback = () => {
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Obdelava plačila...');

  useEffect(() => {
    const processCallback = async () => {
      const route = window.location.pathname.replace(/\/$/, '');
      const resultStatus = ROUTE_STATUS[route] || 'DEBIT_FAILED';
      //const urlParams = new URLSearchParams(window.location.search);
  
      const pending = sessionStorage.getItem('lastnik_payment_pending');
      const pendingData = pending ? JSON.parse(pending) : {};
    
      try {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5100/api/';
        const body = { transactionId: pendingData.transactionId, status: resultStatus };

        await fetch(`${apiBaseUrl}Payments/result`, {
          method: 'POST',
          headers: { 'accept': '*/*', 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify(body)
        });

      } catch (err) {
        console.error('[PaymentCallback] fetch failed:', err);
      }

      sessionStorage.removeItem('lastnik_payment_pending');

      if (resultStatus === 'DEBIT_SUCCESS') {
        setStatus('success');
        setMessage('Plačilo uspešno! Preusmerjam...');
        setTimeout(() => { window.location.href = '/'; }, 1500);
      } else if (resultStatus === 'DEBIT_CANCEL') {
        setStatus('cancel');
        setMessage('Plačilo je bilo preklicano.');
      } else {
        setStatus('error');
        setMessage('Plačilo ni uspelo. Prosim, poskusite znova.');
      }
    };

    processCallback();
  }, []);

  return (
    <div className="payment-callback-container">
      <div className={`callback-status ${status}`}>
        <div className="status-icon">
          {status === 'processing' && (
            <div className="callback-loader" aria-hidden="true">
              <div className="callback-loader-ring"></div>
              <div className="callback-loader-core"></div>
            </div>
          )}
          {status === 'success' && <span>✓</span>}
          {status === 'error' && <span>✕</span>}
          {status === 'cancel' && <span>✕</span>}
        </div>
        <h2>{message}</h2>
        {(status === 'error' || status === 'cancel') && (
          <button onClick={() => window.location.href = '/'}>Nazaj na iskanje</button>
        )}
      </div>
    </div>
  );
};

export default PaymentCallback;
